import { z } from 'zod';
import {
  LeadContactability,
  LeadLifecycleStatus,
  LeadUrgency,
} from '@/models/entities/lead';

export const ContactabilityFilterLabel: Record<ContactabilityFilter, string> = {
  [LeadContactability.Unreachable]: 'Unreachable',
};

export const UrgencyFilterLabel: Record<UrgencyFilter, string> = {
  [LeadUrgency.Overdue]: LeadUrgency.Overdue,
  [LeadUrgency.OverdueSoon]: LeadUrgency.OverdueSoon,
};

export const ChipStatusEnum = z.enum([
  LeadLifecycleStatus.Lead,
  LeadLifecycleStatus.Scheduled,
  LeadLifecycleStatus.InRepair,
  LeadLifecycleStatus.Executed,
]);

export type ChipStatus = z.infer<typeof ChipStatusEnum>;

export const UrgencyFilterEnum = z.enum(LeadUrgency);

export type UrgencyFilter = z.infer<typeof UrgencyFilterEnum>;

export const ContactabilityFilterEnum = z.enum(LeadContactability);

export type ContactabilityFilter = z.infer<typeof ContactabilityFilterEnum>;

export const FilterChipCountSchema = z.object({
  status: ChipStatusEnum,
  count: z.number().min(0),
});

export type FilterChipCount = z.infer<typeof FilterChipCountSchema>;

export const UrgencyFilterCountSchema = z.object({
  urgency: UrgencyFilterEnum,
  count: z.number().min(0),
});

export type UrgencyFilterCount = z.infer<typeof UrgencyFilterCountSchema>;

export const ContactabilityFilterCountSchema = z.object({
  contactability: ContactabilityFilterEnum,
  count: z.number().min(0),
});

export type ContactabilityFilterCount = z.infer<
  typeof ContactabilityFilterCountSchema
>;
